import { graphql } from "@/graphql/codegen"
import "./fragments"

graphql(`
  query ListGlTransactionRows($input: GlTransactionRowListInput!) {
    glTransaction {
      rowList(input: $input) {
        ... on GlTransactionRowListSuccess {
          glTransactionRows {
            ...GlTransactionRowFields
            glTransaction {
              ...GlTransactionBaseFields
              reverseTransaction {
                reason
              }
            }
          }
          pageInfo {
            total
            limit
            offset
          }
        }
        ... on GlTransactionFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
